"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const context_1 = __importDefault(require("./context"));
const useItems_1 = __importDefault(require("./useItems"));
function useDraggingItem() {
    const { dragMonitor } = react_1.default.useContext(context_1.default);
    const items = useItems_1.default();
    return react_1.default.useMemo(() => {
        if (!dragMonitor) {
            return null;
        }
        const dragData = dragMonitor.getItem();
        if (!dragData) {
            return null;
        }
        return items.find(({ id }) => id === dragData.id);
    }, [dragMonitor, items]);
}
exports.default = useDraggingItem;
